import React, { useEffect } from 'react';
import { UALProvider } from 'ual-reactjs-renderer';
import {Helmet} from "react-helmet";
import { anchor, wax, myChain,  currentWebsiteURL, wombat, APP_NAME } from '../data/config';
import { NewListingBody, NewListingCont, SmallButton, TallFiltersCont, testTheme, theme } from '../Styles';
import Error from '../components/Error';
import { useGetAllListings } from '../components/CustomHooks/useGetAllListings';
import LoadingPage from '../components/LoadingPage';
import { Table, TableData, TableHeader, TableRow } from '../data/css/ListingPageStyles';
import { get_ingredient_count } from '../data/functions/listings';

const ListingsPage = () => {

  const [listings, getAllListings, listingsAreLoading] = useGetAllListings();

  useEffect(() => {
    getAllListings();
  }, [])



if(!listingsAreLoading && listings != null){
    return (
        <div id="seo">
          <Helmet>
          <title>Listings - {`${APP_NAME}`}</title>
          <meta name="description" content="Your one stop shop for WAX names" />
          <link rel="canonical" href={`${currentWebsiteURL}/contests`} />
          </Helmet>
      
          <UALProvider chains={[myChain]} authenticators={[anchor, wax, wombat]} appName={APP_NAME}>
          
          <NewListingCont>
              <NewListingBody>
                <TallFiltersCont>
                  <h2>Names For Sale</h2>
                </TallFiltersCont>
                <br/><br/>

    <Table>
      <thead>
        <TableRow>
          <TableHeader></TableHeader>
          <TableHeader>Name</TableHeader>
          <TableHeader>Ingredients</TableHeader>
          <TableHeader>Sold</TableHeader>
        </TableRow>
      </thead>
      <tbody>
        {listings?.sort((a, b) => b.time_created - a.time_created).map((listing, index) => (
          <TableRow key={index}>
            <TableData>
            <a href={`${currentWebsiteURL}/listing/${listing.listing_id}`}>
              <SmallButton>View</SmallButton>
              </a>
              </TableData>
            <TableData>{listing.account_for_sale}</TableData>
            <TableData>{get_ingredient_count(listing)}</TableData>
            <TableData>{listing.total_bought}</TableData>
          </TableRow>
        ))}
      </tbody>
    </Table>

      
              </NewListingBody>
          </NewListingCont>
      
      
      
      
      
      
          </UALProvider>
          <br/><br/><br/>
          </div>
        )
} else if(listingsAreLoading){
    return <LoadingPage />
}
  
}

export default ListingsPage